var BookingScenario = {};

document.addEventListener('DOMContentLoaded', function () {
    var hotel = document.getElementById('mainBookingHotel');
    var adults = document.getElementById('mainBookingAdults');
    var kids = document.getElementById('mainBookingKids');
    var kids2 = document.getElementById('mainBookingKids2');

    var changeEls = [];
    if (hotel) changeEls.push(hotel);
    if (adults) changeEls.push(adults);
    if (kids) changeEls.push(kids);
    if (kids2) changeEls.push(kids2);

    changeEls.forEach(function (el) {
        el.addEventListener('change', function () {
            GetBookingScenario();
        });
    });

    var td = new Intl.DateTimeFormat('en-GB', {
        day: '2-digit',
        month: 'short'
    }).format(new Date());

    // #region ########## Booking Overlay Manager ##########
    document.querySelectorAll('.overlay-back').forEach(function (btn) {
        btn.addEventListener('click', function (e) {
            // Fade out current page and fade in selected page
            var panelId = btn.getAttribute('data-booking-id');

            var bookingPanels = document.querySelectorAll('.bo_panel');

            for (var i = 0; i < bookingPanels.length; i++) {
                if (panelId != bookingPanels[i].getAttribute('data-booking-id')) {
                    bookingPanels[i].classList.remove('active');
                }
                if (panelId == bookingPanels[i].getAttribute('data-booking-id')) {
                    bookingPanels[i].classList.add('active');
                }
            }
        });
    });

    // Animate Opacity Overlay
    document.querySelectorAll('.booking-desktop, .booking-mobile.open-booking-panel').forEach(function (el) {
        el.addEventListener('click', function (e) {

            if (document.body.classList.contains('booking-open'))
            {
                // If it is already open then close it
                var overlay = document.querySelector('.booking-overlay');
                if (overlay) overlay.classList.remove('active');
                document.querySelectorAll('.booking-overlay-dates.Hotel-dates').forEach(function (d) { d.classList.remove('active'); });
                document.body.classList.remove('booking-open');

                // Make sure it doesnt scroll back to the top
                const scrollY = document.body.style.top;
                document.body.style.position = '';
                document.body.style.top = '';
                window.scrollTo(0, parseInt(scrollY || '0') * -1);
            } else {
                // Otherwise open it
                var targetWithData = e.target.closest('[data-booking-id]');
                var selectedHotelID = targetWithData ? targetWithData.getAttribute('data-booking-id') : null;

                if (selectedHotelID > 0) {
                    var mainBookingHotel = document.getElementById('mainBookingHotel');
                    if (mainBookingHotel) mainBookingHotel.value = selectedHotelID;
                }

                const popupScroll = window.scrollY;

                // Stops it scrolling back to the top
                document.body.style.top = '-' + popupScroll + 'px';
                document.body.style.position = 'fixed';

                var overlay = document.querySelector('.booking-overlay');
                if (overlay) overlay.classList.add('active');
                document.body.classList.add('booking-open');

            }
        });
    });

    document.querySelectorAll('.booking-overlay .close, .booking-overlay-background').forEach(function (el) {
        el.addEventListener('click', function (e) {
            e.preventDefault();
            e.stopPropagation();

            var overlay = document.querySelector('.booking-overlay');
            if (overlay) overlay.classList.remove('active');
            document.querySelectorAll('.booking-overlay-dates.Hotel-dates').forEach(function (d) { d.classList.remove('active'); });
            document.body.classList.remove('booking-open');

            // Make sure it doesnt scroll back to the top
            const scrollY = document.body.style.top;
            document.body.style.position = '';
            document.body.style.top = '';
            window.scrollTo(0, parseInt(scrollY || '0') * -1);
        });
    });

    document.addEventListener('keyup', function (e) {
        if (e.key === 'Escape') {
            var overlay = document.querySelector('.booking-overlay');
            if (overlay && overlay.classList.contains('active')) {
                overlay.classList.remove('active');
                document.querySelectorAll('.booking-overlay-dates.Hotel-dates').forEach(function (d) { d.classList.remove('active'); });
                document.body.classList.remove('booking-open');

                // Make sure it doesnt scroll back to the top
                const scrollY = document.body.style.top;
                document.body.style.position = '';
                document.body.style.top = '';
                window.scrollTo(0, parseInt(scrollY || '0') * -1);
            }
        }
    });

    // Animate Opacity Overlay
    document.querySelectorAll('a[href="#book"]').forEach(function (a) {
        a.addEventListener('click', function (e) {

            var targetWithData = e.target.closest('[data-booking-id]');
            var selectedHotelID = targetWithData ? targetWithData.getAttribute('data-booking-id') : null;

            if (selectedHotelID > 0) {
                var mainBookingHotel = document.getElementById('mainBookingHotel');
                if (mainBookingHotel) mainBookingHotel.value = selectedHotelID;
            }

            var overlay = document.querySelector('.booking-overlay');
            if (overlay) overlay.classList.add('active');
            document.body.classList.add('booking-open');
        });
    });

    // #endregion

    // #region ########## Booking Tabs Manager ##########

    document.querySelectorAll('.bo-panel-nav a').forEach(function (btn) {
        btn.addEventListener('click', function (e) {
            e.preventDefault();
            e.stopPropagation();
            // get the booking id from the clicked button
            var panelId = btn.getAttribute('data-booking-id');
            // Change the active state on the button and also on the .bo-panel with the same data-booking-id
            document.querySelectorAll('.bo-panel-nav a').forEach(function (b) {
                if (b.getAttribute('data-booking-id') == panelId) {
                    b.classList.add('active');
                } else {
                    b.classList.remove('active');
                }
            });

            document.querySelectorAll('.bo-panel').forEach(function (p) {
                if (p.getAttribute('data-booking-id') == panelId) {
                    p.classList.add('active');
                } else {
                    p.classList.remove('active');
                }
            });
        });
    });

    // #endregion

    // #region ########## Date pickers ##########

    // Booking Date Picker
    var bookingDatesTrigger = document.querySelector('.booking-date');

    var dateRangeOptions = {
        format: 'DD MMM YYYY'
    };

    // Shared Litepicker initializer to replace daterangepicker
    window.initDateRangePicker = function (trigger, opt) {
        if (!trigger) return;
        try {
            if (typeof Litepicker === 'undefined') return;
            var bookingEl = trigger;
            var startEl = bookingEl.parentElement ? bookingEl.parentElement.querySelector('#bookingStartDate') : null;
            var endEl = bookingEl.parentElement ? bookingEl.parentElement.querySelector('#bookingEndDate') : null;
            var parentEl = document.querySelector('.booking-overlay');
            function fmtMMDDYYYY(d) { return ('0' + (d.getMonth()+1)).slice(-2) + '/' + ('0' + d.getDate()).slice(-2) + '/' + d.getFullYear(); }
            function fmtDDMMM(d) { return d.toLocaleDateString(undefined, { day: '2-digit', month: 'short' }); }

            // Get yesterdays date
            var d = new Date();
            d.setDate(d.getDate() - 1); // Prevent selecting past dates


            var picker = new Litepicker({
                element: bookingEl,
                parentEl: parentEl,
                singleMode: false,
                position: 'static',
                autoApply: true,
                minDate: d, // Prevent selecting past dates
                format: 'DD MMM YYYY'
            });

            if (startEl && endEl && startEl.value && endEl.value) {
                try {
                    var sParts = startEl.value.split('/');
                    var eParts = endEl.value.split('/');
                    if (sParts.length === 3 && eParts.length === 3) {
                        var sDate = new Date(parseInt(sParts[2],10), parseInt(sParts[0],10)-1, parseInt(sParts[1],10));
                        var eDate = new Date(parseInt(eParts[2],10), parseInt(eParts[0],10)-1, parseInt(eParts[1],10));
                        try { picker.setDateRange(sDate, eDate); } catch (err) {}
                        if (!isNaN(sDate.getTime()) && !isNaN(eDate.getTime())) {
                            bookingEl.innerHTML = fmtDDMMM(sDate) + ' - ' + fmtDDMMM(eDate);
                        }
                    }
                } catch (err) { }
            }

            picker.on('selected', function (startDate, endDate) {
                var sd = new Date(startDate.getTime());
                var ed = new Date(endDate.getTime());
                if (!isNaN(sd.getTime()) && !isNaN(ed.getTime())) {
                    bookingEl.innerHTML = fmtDDMMM(sd) + ' - ' + fmtDDMMM(ed);
                    if (startEl) startEl.value = fmtMMDDYYYY(sd);
                    if (endEl) endEl.value = fmtMMDDYYYY(ed);

                    setTimeout(function () {
                        document.querySelectorAll('.booking-overlay-dates.Hotel-dates').forEach(function (d) { d.classList.remove('active'); });
                    }, 500);
                } else {
                    bookingEl.innerHTML = 'Choose a Date';
                    if (startEl) startEl.value = '';
                    if (endEl) endEl.value = '';
                }
            });

            bookingEl._litepicker = picker;
        } catch (e) { console.error('initDateRangePicker error', e); }
    };

    // #endregion

    // #region ########## Restaurant Code ##########

    var restaurantsPicker = document.querySelector('#mainRestaurants')
    restaurantsPicker.addEventListener('change', function (e) {
        e.preventDefault();
        e.stopPropagation();
        // get the booking id from the selected option value
        var panelId = restaurantsPicker.value;
        // Change the active state on the button and also on the .bo-panel with the same data-booking-id
        document.querySelectorAll('.restaurant-panel').forEach(function (b) {
            if (b.getAttribute('data-restaurant-id') == panelId) {
                b.classList.add('active');
            } else {
                b.classList.remove('active');
            }
        });

        document.querySelectorAll('.restaurant-panel').forEach(function (p) {
            if (p.getAttribute('data-restaurant-id') == panelId) {
                p.classList.add('active');
            } else {
                p.classList.remove('active');
            }
        });
    });

    // #endregion

    // Initialize Litepicker instances where present
    if (typeof Litepicker !== 'undefined') {
        document.querySelectorAll('.booking-date').forEach(function(el){ window.initDateRangePicker(el, dateRangeOptions); });
    } else if (typeof window.initDateRangePicker === 'function') {
        window.initDateRangePicker(bookingDatesTrigger, dateRangeOptions);
    }


});

function GetBookingScenario() {
    //do an API call to
    var apiUrl = '/Umbraco/Api/BookingScenariosApi/GetBestBookingScenario';

    // Get the selections
    var hotelEl = document.getElementById('mainBookingHotel');
    var adultsEl = document.getElementById('mainBookingAdults');
    var kidsEl = document.getElementById('mainBookingKids');
    var kids2El = document.getElementById('mainBookingKids2');

    BookingScenario.SelectedHotel = null;
    if (hotelEl) {
        var selectedOption = hotelEl.options[hotelEl.selectedIndex];
        if (selectedOption) {
            // data-internal-booking-id -> dataset.internalBookingId
            BookingScenario.SelectedHotel = selectedOption.getAttribute('data-internal-booking-id') || selectedOption.dataset.internalBookingId || null;
        }
    }

    BookingScenario.SelectedAdults = adultsEl ? adultsEl.value : null;
    var kidsVal = kidsEl ? parseInt(kidsEl.value, 10) || 0 : 0;
    var kids2Val = kids2El ? parseInt(kids2El.value, 10) || 0 : 0;
    BookingScenario.SelectedChildren = kidsVal + kids2Val;

    // Clear the reply
    BookingScenario.HasReply = false;
    BookingScenario.Reply = null;

    // Call the API
    fetch(apiUrl, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(BookingScenario)
    }).then(function (response) {
        if (!response.ok) throw new Error('Network response was not ok');
        return response.json();
    }).then(function (result) {
        BookingScenario = result;

        // If we have a reply then we can show it
        if (BookingScenario && BookingScenario.HasReply) {

            var submitBtn = document.getElementById('mainBookingSubmitBtn');
            // Disable the button if the button needs disabled
            if (BookingScenario.Reply && BookingScenario.Reply.DisableBookButton) {
                if (submitBtn) submitBtn.disabled = true;
            } else {
                if (submitBtn) submitBtn.disabled = false;
            }

            // Show the message
            document.querySelectorAll('.booking-message').forEach(function (el) { el.classList.add('active'); });

            // Add the message HTML
            document.querySelectorAll('.booking-message-content').forEach(function (el) { el.innerHTML = BookingScenario.Reply ? BookingScenario.Reply.Message : ''; });

            // If we have a phone number then add this in
            if (BookingScenario.Reply && BookingScenario.Reply.PhoneNumber && BookingScenario.Reply.PhoneNumber.length > 0) {
                document.querySelectorAll('.booking-message-phone a').forEach(function (a) { a.setAttribute('href', 'tel:' + BookingScenario.Reply.PhoneNumber); });
                document.querySelectorAll('.booking-message-phone').forEach(function (el) { el.classList.add('active'); });
            } else {
                document.querySelectorAll('.booking-message-phone').forEach(function (el) { el.classList.remove('active'); });
            }

            // If we have an email then add this in
            if (BookingScenario.Reply && BookingScenario.Reply.Email && BookingScenario.Reply.Email.length > 0) {
                document.querySelectorAll('.booking-message-email a').forEach(function (a) { a.setAttribute('href', 'mailto:' + BookingScenario.Reply.Email); });
                document.querySelectorAll('.booking-message-email').forEach(function (el) { el.classList.add('active'); });
            } else {
                document.querySelectorAll('.booking-message-email').forEach(function (el) { el.classList.remove('active'); });
            }

        } else {
            // Otherwise hide it and remove the disabled state from the button
            document.querySelectorAll('.booking-message').forEach(function (el) { el.classList.remove('active'); });
            var submitBtn = document.getElementById('mainBookingSubmitBtn');
            if (submitBtn) submitBtn.disabled = false;
        }

    }).catch(function (err) {
        // Do nothing on error
    });

}
